import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { billingApi, type CreditAccount, type UsageDashboard } from '../../api/billing';

export function UsageDashboardPage() {
  const [usage, setUsage] = useState<UsageDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void billingApi.usageDashboard((getWorkspaceId() ?? '')).then(setUsage).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Usage Dashboard</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {usage && Object.entries(usage.by_type ?? {}).map(([k, v]) => (
          <div key={k} className="rounded-xl border p-4 dark:border-slate-700">
            <p className="text-sm text-slate-500">{k}</p>
            <p className="mt-1 text-xl font-semibold">{v}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function CreditWalletPage() {
  const [credits, setCredits] = useState<CreditAccount | null>(null);
  const [amount, setAmount] = useState(1000);
  const [error, setError] = useState('');

  const refresh = () => {
    void billingApi.creditBalance((getWorkspaceId() ?? '')).then(setCredits).catch((e) => setError(String(e)));
  };

  useEffect(refresh, []);

  const purchase = async () => {
    setError('');
    try {
      await billingApi.purchaseCredits(amount, (getWorkspaceId() ?? ''));
      refresh();
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">AI Credit Wallet</h1>
      <p className="mt-2 text-2xl font-semibold">{credits?.available ?? 0} credits available</p>
      <div className="mt-4 flex gap-2">
        <input type="number" className="rounded border px-2 py-1 text-sm dark:border-slate-700 dark:bg-slate-900" value={amount} onChange={(e) => setAmount(Number(e.target.value))} />
        <button type="button" className="rounded bg-slate-900 px-3 py-1 text-sm text-white dark:bg-slate-100 dark:text-slate-900" onClick={purchase}>Purchase</button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
    </div>
  );
}
